import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { Toaster } from 'react-hot-toast'

// Global runtime error guard to surface errors to logs and E2E
if (typeof window !== 'undefined') {
  const prev = window.onerror
  window.onerror = function (message, source, lineno, colno, error) {
    try {
      console.error('[RuntimeError]', { message, source, lineno, colno, error })
      ;(window as any).__APP_RUNTIME_ERROR__ = {
        message: String(message || ''),
        source: String(source || ''),
        lineno: Number(lineno || 0),
        colno: Number(colno || 0),
      }
    } catch {}
    return prev ? prev(message as any, source as any, lineno as any, colno as any, error as any) : false
  }

  // 강제 최신화 장치: 서버 버전이 바뀌면 캐시 삭제 후 강제 새로고침
  ;(async () => {
    try {
      const raw = import.meta.env.VITE_API_URL || 'http://localhost:5000'
      const base = raw.replace(/\/$/, '').replace(/\/api$/, '')
      const res = await fetch(`${base}/health`, { cache: 'no-store' })
      const json = await res.json().catch(() => null)
      const serverVersion = json?.version || ''
      const localVersion = localStorage.getItem('appVersion') || ''
      if (serverVersion && serverVersion !== localVersion) {
        // 캐시 비우기
        if ('caches' in window) {
          const names = await caches.keys()
          await Promise.all(names.map((n) => caches.delete(n)))
        }
        localStorage.setItem('appVersion', serverVersion)
        // 서비스워커 강제 업데이트
        if ('serviceWorker' in navigator) {
          const regs = await navigator.serviceWorker.getRegistrations()
          for (const r of regs) {
            try { await r.unregister() } catch {}
          }
        }
        // 강제 새로고침
        window.location.reload()
      } else if (!serverVersion) {
        // 헬스 파싱 실패/404 대응: 1회 캐시 청소 후 재시도
        if (!localStorage.getItem('healthFixApplied')) {
          try {
            if ('caches' in window) {
              const names = await caches.keys()
              await Promise.all(names.map((n) => caches.delete(n)))
            }
            if ('serviceWorker' in navigator) {
              const regs = await navigator.serviceWorker.getRegistrations()
              for (const r of regs) { try { await r.unregister() } catch {} }
            }
          } catch {}
          localStorage.setItem('healthFixApplied', '1')
          window.location.reload()
        }
      }
    } catch {}
  })()
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    <Toaster
      position="top-center"
      reverseOrder={false}
      gutter={8}
      containerClassName=""
      containerStyle={{}}
      toastOptions={{
        // 기본 설정
        duration: 4000,
        style: {
          background: '#363636',
          color: '#fff',
        },
        // 성공 토스트
        success: {
          duration: 3000,
          style: {
            background: '#10b981',
            color: '#fff',
          },
        },
        // 에러 토스트
        error: {
          duration: 4000,
          style: {
            background: '#ef4444',
            color: '#fff',
          },
        },
      }}
    />
  </React.StrictMode>,
)
